/** Truncate chart labels for axis/legend display. */
export function truncateChartLabel(text, maxLength = 22) {
  if (!text) return '';
  const value = String(text);
  if (value.length <= maxLength) return value;
  return `${value.slice(0, Math.max(1, maxLength - 1))}…`;
}
